/**
 * Demo accounts for local quick-login — keep in sync with:
 *   credora360-api/scripts/seed_admin.py (admin)
 *   credora360-api/scripts/demo_users.py (all other roles)
 */

export const DEV_DEMO_PASSWORD = "ChangeMe123!";

export const DEV_LOGIN_USERS = [
  { role: "Super Admin", email: "admin@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Branch Manager", email: "manager@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Loan Officer", email: "officer@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Credit Analyst", email: "analyst@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Collections", email: "collections@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Cashier", email: "cashier@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Customer Support", email: "support@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Call Center", email: "agent@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Auditor", email: "auditor@credora360.co.tz", password: DEV_DEMO_PASSWORD },
  { role: "Read Only", email: "viewer@credora360.co.tz", password: DEV_DEMO_PASSWORD },
];

/** True only in Vite dev server (`npm run dev`); stripped/false in production builds. */
export function isLocalDevLoginEnabled() {
  return import.meta.env.DEV;
}
